import { isArray } from '../inspect';

const ERROR_PREFIX = 'App';

/**
 * Ошибка
 */
export default class BaseError extends Error {
  /**
   * @param {String | String[]} messages
   */
  constructor(messages) {
    const message = isArray(messages) ? messages.join('. ') : messages;

    super(`[${ERROR_PREFIX}] ${message}`);
    this.name = this.constructor.name;
  }
}
